//上传cos配置
export const upConfig = {
    Bucket: 'skin525-1316488073',
    Region: 'ap-nanjing'
}
//上传目录
export const upDir = 'skin525'
